import type { ReactNode } from "react";
import type { SubscriptionView } from "../api/accountApi";
import { formatUsageMonth, includedPercent } from "../lib/accountFormat";
import { LOTSE_PRICE } from "../lib/portalCopy";
import { IconCompass } from "./icons";

export function LotseMark({ size = "m" }: { size?: "s" | "m" }) {
  return (
    <span className={`lotse-mark lotse-mark--${size}`} aria-hidden="true">
      <IconCompass />
    </span>
  );
}

function splitPrice(text: string): { amount: string; unit: string | null } {
  const match = /^(.*?)\s*\/\s*(.*)$/.exec(text);
  return match ? { amount: match[1], unit: match[2] } : { amount: text, unit: null };
}

/** KI-Lotse as an add-on band hanging off the tiers, ringed by the app's AI gradient. */
export function LotseAddon({
  sub,
  priceCopy,
  action,
}: {
  sub: SubscriptionView;
  priceCopy?: string | null;
  action: ReactNode;
}) {
  const lotse = sub.ai_lotse;
  const price = splitPrice(priceCopy || LOTSE_PRICE);
  const usage = lotse.entitled ? lotse.usage : null;
  const percent = usage ? includedPercent(usage.estimated_cost_micro_eur, usage.monthly_budget_micro_eur) : null;

  return (
    <article className="lotse" aria-label="KI-Lotse">
      <span className="lotse__plus" aria-hidden="true">+</span>
      <div className="lotse__inner">
        <LotseMark />
        <div className="lotse__copy">
          <h3>
            KI-Lotse
            {lotse.entitled ? <span className="lotse__state">{lotse.cancel_at_period_end ? "Gekündigt" : "Aktiv"}</span> : null}
          </h3>
          <p>Ihr KI-Assistent in der App. Läuft über Amazon Bedrock in Stockholm (EU), nur mit Ihrer Einwilligung.</p>
          {usage && percent != null ? (
            <div className="lotse__usage">
              <div className="lotse__meter" role="meter" aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-label="Verbrauchtes Kontingent">
                <span style={{ width: `${percent}%` }} />
              </div>
              <span>
                {formatUsageMonth(usage.month_utc)}: <span className="data">{percent} %</span> genutzt
              </span>
            </div>
          ) : null}
        </div>
        {!lotse.entitled ? (
          <p className="lotse__price">
            <strong className="data">{price.amount}</strong>
            {price.unit ? <small>/ {price.unit}</small> : null}
          </p>
        ) : null}
        <div className="lotse__action">{action}</div>
      </div>
    </article>
  );
}
